import React, {Fragment} from "react";
import {Grid} from "@material-ui/core";
import CompanyCard from "./CompanyCard";
import {Company} from "../../../../models/Company";

export type RenderCompaniesProps = {
  companies: Company[];
  onClick: (id: string) => void;
  onEdit: (id: string) => void;
}

const RenderCompanies = (p: RenderCompaniesProps) => {
  const { companies, ...rest } = p;

  return (
    <Fragment>
      {companies.map((item, index) => {
        return (
          <Grid item md={4} sm={6} xs={12} lg={3} key={index}>
            <CompanyCard {...rest} item={item}/>
          </Grid>
        )
      })}
    </Fragment>
  )
}

export default RenderCompanies